// Demo authentication for testing UI without backend
import { DEMO_USERS } from './dummyData';

export const DEMO_CREDENTIALS = [
  {
    email: 'priya@demo.com',
    password: 'demo123',
    userId: 'demo_user_1',
    name: 'Priya Sharma'
  },
  {
    email: 'rahul@demo.com',
    password: 'demo123',
    userId: 'demo_user_2',
    name: 'Rahul Verma'
  },
  {
    email: 'ananya@demo.com',
    password: 'demo123',
    userId: 'demo_user_3',
    name: 'Ananya Singh'
  }
];

export const handleDemoLogin = (email: string, password: string) => {
  const credential = DEMO_CREDENTIALS.find(
    c => c.email === email && c.password === password
  );

  if (!credential) {
    return null;
  }

  const user = DEMO_USERS.find(u => u._id === credential.userId);
  if (!user) {
    return null;
  }

  // Store demo session
  localStorage.setItem('demoMode', 'true');
  localStorage.setItem('demoUserId', credential.userId);
  localStorage.setItem('token', 'demo_token_' + credential.userId);
  localStorage.setItem('user', JSON.stringify(user));

  return {
    user,
    token: 'demo_token_' + credential.userId
  };
};

export const isDemoLogin = () => {
  const token = localStorage.getItem('token');
  return token?.startsWith('demo_token_');
};

export const getDemoUserFromToken = () => {
  if (!isDemoLogin()) return null;
  
  const userStr = localStorage.getItem('user');
  if (!userStr) return null;
  
  try {
    return JSON.parse(userStr);
  } catch {
    return null;
  }
};

export const logoutDemo = () => {
  localStorage.removeItem('demoMode');
  localStorage.removeItem('demoUserId');
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};
